
function fn () {

    this.$eventBus.emit('show-dialog-page', {
      page: 'fatture-vendita-import-compensazioni',
      title: 'Importa Compensazioni',
      maximize: false,
    })
}

export default {
  'bindTo': 'this',
  'method': fn,
}
